import { tempCollection } from '@frontend/store/showcase/common/collection/_temp/tempCollection'

export default () => ({
  // TODO: fetch
  /** @type {ShowcaseCollection|null} */
  collection: tempCollection,
})
